import React, { useState, useEffect, useRef } from "react";
import { Text } from "../../../../styled-components/text";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import * as Style from "./styles/user-defined";
import { Button } from "../../../../styled-components/button";
import IconInput from "../../../../styled-components/input/icon-input";
import {
  Input,
  InputGroup,
} from "../../../../styled-components/input/styles/input";
import AddModal from "../../../../styled-components/modal/add-modal/add-modal";
import UpdateModal from "../../../../styled-components/modal/update-modal/update-modal";
import MonteCarlo from "../monte-carlo/monte-carlo";
import StaticReturnRate from "../static-return-rate/static-return-rate";
import UserDefinedRow from "./components/UserDefinedRow";
import { UserDefinedModal } from "./components/UserDefinedModal";
import TAX_AND_INFLATION_API from "../../../../../apis/tax_and_inflation.api";
import NewLoader from "../../../../styled-components/loader/NewLoader";
import swal from "sweetalert";
import { useDispatch } from "react-redux";
import { setSelectedStaticRateofReturn } from "../../../../../redux/slices/inventorySlice";
function UserDefined({ handleRatesOfReturnObject, nextForm, preForm }) {
  const userDefinedPayloadRow = {
    year: "",
    percentage: "",
  };
  const cardsMainRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { styles } = defaultStyles;
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [noOfYears, setNoOfYears] = useState(null);
  const [fieldsList, setFieldsList] = useState([]);
  const [userDefinedPayload, setUserDefinedPayload] = useState([]);
  const [userDefinedAllData, setUserDefinedAllData] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState();
  const dispatch = useDispatch();

  const [updatedObject, setUpdateObject] = useState({
    year: "",
    percentage: "",
  });

  const handleUserDefinedData = (index, obj) => {
    console.log("index", index);
    console.log("obj Hereee", obj);
    const { name, value } = obj;

    const copyUserDefinedPayload = [...userDefinedPayload];

    copyUserDefinedPayload[index][name] = value ? +value : null;

    setUserDefinedPayload(copyUserDefinedPayload);
  };

  const handleUserDefinedUpdatedData = (obj) => {
    const { name, value } = obj;

    setUpdateObject({
      ...updatedObject,
      [name]: value ? +value : null,
    });
  };

  const submitData = () => {
    userDefinedAllData.push(...userDefinedPayload);

    handleRatesOfReturnObject(userDefinedAllData);
    console.log("userDefinedAllData", userDefinedAllData);
    handleSubmit(userDefinedAllData);
    dispatch(setSelectedStaticRateofReturn(null));
    setNoOfYears(null);
  };
  const handleSubmit = async (data) => {
    try {
      setLoading(true);
      let payload = {
        userDefined: data,
      };
      console.log("dataPayload", payload);
      let res = await TAX_AND_INFLATION_API.createUserDefined(payload);
      if (res && res.status === 200) {
        setDataList([]);
        await getUserDefined(1);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while creating tax credit", error);
    }
  };
  const getUserDefined = async (page) => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.getUserDefined(page);
      if (data && data.data) {
        // setDataList(data.data.rows);
        setDataList((prevState) => [...prevState, ...data.data.rows]);

        setTotalPages(Math.ceil(data.data.count && data.data.count / 10));
        setCurrentPage(page);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };
  useEffect(() => {
    getUserDefined(1);
  }, []);

  const handleScroll = () => {
    const element = cardsMainRef && cardsMainRef.current;
    if (!element) return;

    const { scrollTop, scrollHeight, clientHeight } = element;

    if (scrollTop + clientHeight >= scrollHeight && currentPage < totalPages) {
      getUserDefined(currentPage + 1);
    }
  };

  useEffect(() => {
    const element = cardsMainRef && cardsMainRef.current;
    if (!element) return;

    element.addEventListener("scroll", handleScroll);
    return () => {
      element.removeEventListener("scroll", handleScroll);
    };
  }, [currentPage, totalPages]);

  const nextComponent = {
    name: "monteCarlo",
    title: "Monte Carlo",
    isMulti: true,
    component: MonteCarlo,
    isMulti: true,
  };

  const preComponent = {
    name: "staticReturnRate",
    title: "Static Rate of Return",
    isMulti: false,
    component: StaticReturnRate,
  };
  const fields = {
    year: {
      Component: Input,
      name: "year",
      title: "Year",
      type: "text",
      onChange: handleUserDefinedData,
    },
    percentage: {
      Component: IconInput,
      value: {
        style: styles.textInput.smallTextInput,
        name: "percentage",
        title: "Percentage",
        icon: "%",
        iconPosition: "end",
        onChange: handleUserDefinedData,
      },
    },
  };

  const update_fields = [
    {
      Component: Input,
      name: "year",
      title: "Year",
      type: "text",
      value: updatedObject["year"],

      onChange: (event) => handleUserDefinedUpdatedData(event.target),
    },
    {
      Component: IconInput,
      value: {
        style: styles.textInput.smallTextInput,
        name: "percentage",
        title: "Percentage",
        icon: "%",
        value: updatedObject["percentage"],
        iconPosition: "end",
        onChange: (event) => handleUserDefinedUpdatedData(event.target),
      },
    },
  ];

  const handelCloseModal = () => {
    setShowModal(false);
    setShowUpdateModal(false);
    setNoOfYears(null);
  };

  const getSelectedRow = (idx) => {
    setShowUpdateModal(true);

    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    const selectedRow =
      dataList &&
      dataList.filter((row, index) => {
        return row.id == idx;
      });

    setUpdateObject(selectedRow[0]);
  };

  const updateRow = async () => {
    // userDefinedAllData[selectedIndex] = updatedObject;
    // handleRatesOfReturnObject(userDefinedAllData);
    let payload = {
      id: updatedObject["id"],
      year: updatedObject && updatedObject["year"] && +updatedObject["year"],
      percentage:
        updatedObject &&
        updatedObject["percentage"] &&
        +updatedObject["percentage"],
    };
    try {
      setLoading(true);
      let res = await TAX_AND_INFLATION_API.updateUserDefined(payload);
      if (res && res.status === 200) {
        setDataList([]);
        await getUserDefined(1);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while updating userdefined credit", error);
    }
  };

  const deleteRow = (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this ?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let res = await TAX_AND_INFLATION_API.deleteUserDefined(id);
          if (res && res.status === 200) {
            swal("Deleted!", "Your User Defined has been deleted.", "success");
            setDataList([]);
            await getUserDefined(1);
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log("error while updating User Defined", error);
        }
      }
    });
  };

  const handleYearsData = () => {
    const currentYear = new Date().getFullYear(); // Get the current year

    // Clear the existing payload and fields list before appending
    userDefinedPayload.length = 0;
    fieldsList.length = 0;

    for (let i = 0; i < noOfYears; i++) {
      const yearValue = currentYear + i; // Get the year for each iteration

      // Push the year and percentage values to the payload
      userDefinedPayload.push({ year: yearValue, percentage: "" });

      // Add the year value directly inside the 'year' object in fieldsList
      fieldsList.push({
        year: {
          ...fields.year, // Spread the 'year' properties from the fields object
          value: yearValue.toString(), // Set the value for the year
        },
        percentage: fields.percentage, // Keep the percentage object as it is
      });
    }

    setShowModal(true);
  };

  console.log("yearsPauload", userDefinedPayload);
  console.log("fieldsList", fieldsList);
  return (
    <div>
      <Style.MainContainer style={{position:"relative"}}>
        <h3 style={{ color: "#2a3da3", fontWeight: "600", fontSize: "28px" }}>
          User Defined Return
        </h3>
        <InputGroup>
          <Text style={styles.text.labelBoldText} padding="0rem 0 1rem 0 ">
            How Many Years
          </Text>
          <Input
            value={noOfYears ? noOfYears : ""}
            name="howManyYears"
            onChange={(event) => setNoOfYears(event.target.value)}
          />
        </InputGroup>
        <Button
          disabled={noOfYears && noOfYears ? false : true}
          style={{
            opacity: noOfYears ? "1" : "0.5",
            cursor: noOfYears ? "pointer" : "not-allowed",
          }}
          onClick={() => handleYearsData()}
        >
          Apply
        </Button>

        <div
          style={{
            width: "100%",
            rowGap: "2rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "2rem",
            maxHeight: "25rem",
            padding: "1rem",
            overflowY: "auto",
          }}
          ref={cardsMainRef}
        >
          {dataList && dataList.length > 0 && (
            <UserDefinedRow
              // key={index}
              // item={item}
              getSelectedRow={getSelectedRow}
              deleteRow={deleteRow}
              // index={index}
              allItems={dataList && dataList}
            />
          )}
        </div>
        <Style.ButtonsContainer>
          <button
            className="tax-inflation-prev-button"
            onClick={() => preForm(preComponent)}
          >
            Previous
          </button>
          {/*  <button
            className="tax-inflation-next-button"
            onClick={() => nextForm(nextComponent)}
          >
            Next
          </button> */}
          <Button
            onClick={() => {
              handleRatesOfReturnObject(dataList);
            }}
          >
            Submit
          </Button>
        </Style.ButtonsContainer>
        <NewLoader isLoading={loading} />
      </Style.MainContainer>
      {/*<UserDefinedModal
        title={"Add User Defined Result"}
        open={showModal}
        fields={fieldsList}
        // handleChange={handleInputChnage}
        handleCancel={handelCloseModal}
        handleSave={submitData}
      /> */}
      <AddModal
        show={showModal}
        close={handelCloseModal}
        fields={fieldsList}
        modalTitle="Add User Defined Result"
        obj="nestedObj"
        submitData={submitData}
      />
      <UpdateModal
        show={showUpdateModal}
        close={handelCloseModal}
        modalTitle="Update User Defined Result"
        fields={update_fields}
        updateRow={updateRow}
      />
    </div>
  );
}

export default UserDefined;
